// extracted by mini-css-extract-plugin
module.exports = {"Page404":"Page404_Page404__1gG07","Header":"Page404_Header__3Xwtr"};